import { Injectable } from '@angular/core';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot, UrlTree, Router } from '@angular/router';
import { Observable, of } from 'rxjs';
import { map, take, switchMap } from 'rxjs/operators';
import { adminRoles } from '../constants/constants';
import { AuthService } from '../services/auth.service';

@Injectable({
  providedIn: 'root'
})
export class AdminGuard implements CanActivate {
  constructor(private authService: AuthService, private router: Router) {}

  canActivate(
    route: ActivatedRouteSnapshot,
    state: RouterStateSnapshot): Observable<boolean | UrlTree> | Promise<boolean | UrlTree> | boolean | UrlTree {
    

    return this.authService.isLoggedIn$.pipe(
      take(1),
      switchMap(isLoggedIn => {
        if (!isLoggedIn) {
          return of(this.router.createUrlTree(['/']));
        }

        return this.authService.userRoles$.pipe(
          take(1),
          map(roles => {
            const hasAllowedRole = roles.some(role => adminRoles.includes(role));

            if (hasAllowedRole) {
              return true;
            } else {
              return this.router.createUrlTree(['/']);
            }
          })
        );
      })
    );
  }
}
